import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6de6eba")

_pushScopeId("data-v-a6de6eba")
const _hoisted_1 = { class: "progress-bar" }
const _hoisted_2 = {
  class: "progress-bar-fill",
  ref: "progressBarFill"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, null, 512),
    _createVNode("div", {
      class: "progress-bar-tooltip",
      ref: "progressTooltip"
    }, _toDisplayString(_ctx.progressFill) + "%", 513)
  ]))
})